export enum TaskConfigurationMessageType {
    WARN = 'warn',
    INFO = 'info',
}
